import i18n from '../../i18n';

export class Text {
  static get marketingItemTitle(): string {
    return i18n._translate('New Library*', {
      context: 'A heading indicating a new part of the app that has more workouts.',
    });
  }

  static get marketingItemDescription(): string {
    return i18n._translate('Use the search icon to filter workout options!', {
      context: 'A paragraph explaining how to use an icon to show or hide workouts.',
    });
  }

  static get paramountItemRunTitle(): string {
    return i18n._translate('Maitake Te Moa Run, North Coast, Rapa Nui', {
      context: 'The title of a running workout and its location.',
    });
  }

  static get paramountItemCycleTitle(): string {
    return i18n._translate('Fantasy Beach Endurance Ride, Priory, Jamaica', {
      context: 'The title of a cycling workout and its location.',
    });
  }

  static get paramountItemRowerTitle(): string {
    return i18n._translate('Push Your Pace, Ilha Grande, Atlantic Ocean, Brazil', {
      context: 'The title of a rower workout and its location.',
    });
  }

  static get paramountItemStrengthTitle(): string {
    return i18n._translate('Yumani Cross Train, Lake Titicaca, Bolivia', {
      context: 'The title of a strength workout and its location.',
    });
  }

  static get paramountItemLeadline(): string {
    return i18n._translate('FEATURED*', {
      context: 'A leadline describing that the workout is featured.',
    });
  }

  static get paramountItemActionText(): string {
    return i18n._translate('View Details', {
      context: 'A link or button that can be clicked letting the user know there is more information.',
    });
  }
}
